import React from "react";
import {
  Button,
  Col,
  DatePicker,
  Icon,
  Input,
  InputNumber,
  Row,
  Select,
} from "antd";
import NumberFormat from "react-number-format";

export const getColumnDateSearchProps = (
  dataIndex,
  handleReset,
  handleSearch
) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Row type="flex" gutter={4}>
        <Col>
          <Select
            value={selectedKeys ? selectedKeys[1] : "equal"}
            onChange={(value) =>
              setSelectedKeys(
                value
                  ? selectedKeys
                    ? [selectedKeys[0], value]
                    : [null, value]
                  : []
              )
            }
          >
            <Select.Option value="equal">=</Select.Option>
            <Select.Option value="greaterThan">&gt;</Select.Option>
            <Select.Option value="greaterOrEqualThan">&ge;</Select.Option>
            <Select.Option value="lessThan">&lt;</Select.Option>
            <Select.Option value="lessOrEqualThan">&le;</Select.Option>
          </Select>
        </Col>
        <Col>
          <DatePicker
            value={selectedKeys && selectedKeys[0]}
            placeholder="01/01/2000"
            format={"DD/MM/YYYY"}
            onChange={(date) =>
              setSelectedKeys(
                date
                  ? selectedKeys && selectedKeys.length > 1
                    ? [date, selectedKeys[1]]
                    : [date, "equal"]
                  : []
              )
            }
            onOk={() => handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        </Col>
      </Row>

      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm)}
        icon="search"
        size="small"
        style={{
          width: 90,
          marginRight: 8,
          background: "#684e94",
          borderColor: "none",
          border: "none",
        }}
      />
      <Button
        onClick={() => handleReset(clearFilters)}
        icon="delete"
        size="small"
        style={{ width: 90 }}
      />
    </div>
  ),
  filterIcon: (filtered) => (
    <Icon type="search" style={{ color: filtered ? "#684e94" : undefined }} />
  ),
});

export const getColumnDateWithBetweenSearchProps = (
  dataIndex,
  handleReset,
  handleSearch
) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Row type="flex" gutter={4}>
        <Col>
          <Select
            value={selectedKeys ? selectedKeys[1] : "equal"}
            onChange={(value) =>
              setSelectedKeys(
                value
                  ? selectedKeys
                    ? [selectedKeys[0], value]
                    : [null, value]
                  : []
              )
            }
          >
            <Select.Option value="equal">=</Select.Option>
            <Select.Option value="greaterThan">&gt;</Select.Option>
            <Select.Option value="greaterOrEqualThan">&ge;</Select.Option>
            <Select.Option value="lessThan">&lt;</Select.Option>
            <Select.Option value="lessOrEqualThan">&le;</Select.Option>
            <Select.Option value="between">entre</Select.Option>
          </Select>
        </Col>
        {selectedKeys && selectedKeys[1] === "between" ? (
          <>
            <Col>
              <DatePicker
                value={selectedKeys && selectedKeys[0]}
                placeholder="01/01/2000"
                format={"DD/MM/YYYY"}
                onChange={(date) =>
                  setSelectedKeys(
                    date
                      ? selectedKeys && selectedKeys.length > 1
                        ? [date, selectedKeys[1], selectedKeys[2]]
                        : [date, "equal", selectedKeys[2]]
                      : []
                  )
                }
                onPressEnter={() => handleSearch(selectedKeys, confirm)}
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
            </Col>
            <Col>
              <DatePicker
                value={selectedKeys && selectedKeys[2]}
                placeholder="01/01/2000"
                format={"DD/MM/YYYY"}
                onChange={(date) =>
                  setSelectedKeys(
                    date
                      ? selectedKeys && selectedKeys.length > 1
                        ? [selectedKeys[0], selectedKeys[1], date]
                        : [selectedKeys[0], "equal", date]
                      : []
                  )
                }
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
            </Col>
          </>
        ) : (
          <Col>
            <DatePicker
              value={selectedKeys && selectedKeys[0]}
              placeholder="01/01/2000"
              format={"DD/MM/YYYY"}
              onChange={(date) =>
                setSelectedKeys(
                  date
                    ? selectedKeys && selectedKeys.length > 1
                      ? [date, selectedKeys[1]]
                      : [date, "equal"]
                    : []
                )
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
          </Col>
        )}
      </Row>

      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm)}
        icon="search"
        size="small"
        style={{
          width: 90,
          marginRight: 8,
          background: "#684e94",
          borderColor: "none",
          border: "none",
        }}
      />
      <Button
        onClick={() => handleReset(clearFilters)}
        icon="delete"
        size="small"
        style={{ width: 90 }}
      />
    </div>
  ),
  filterIcon: (filtered) => (
    <Icon type="search" style={{ color: filtered ? "#684e94" : undefined }} />
  ),
});

export const getColumnSearchProps = (dataIndex, handleReset, handleSearch) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        value={selectedKeys && selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => handleSearch(selectedKeys, confirm)}
        style={{ width: 188, marginBottom: 8, display: "block" }}
      />
      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm)}
        icon="search"
        size="small"
        style={{
          width: 90,
          marginRight: 8,
          background: "#684e94",
          borderColor: "none",
          border: "none",
        }}
      />
      <Button
        onClick={() => handleReset(clearFilters)}
        icon="delete"
        size="small"
        style={{ width: 90 }}
      />
    </div>
  ),
  filterIcon: (filtered) => (
    <Icon type="search" style={{ color: filtered ? "#684e94" : undefined }} />
  ),
});

export const getColumnNumberSearchProps = (
  dataIndex,
  handleReset,
  handleSearch
) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Row type="flex" gutter={4}>
        <Col>
          <Select
            value={selectedKeys ? selectedKeys[1] : "equal"}
            onChange={(value) =>
              setSelectedKeys(
                value
                  ? selectedKeys
                    ? [selectedKeys[0], value]
                    : [null, value]
                  : []
              )
            }
          >
            <Select.Option value="equal">=</Select.Option>
            <Select.Option value="greaterThan">&gt;</Select.Option>
            <Select.Option value="greaterOrEqualThan">&ge;</Select.Option>
            <Select.Option value="lessThan">&lt;</Select.Option>
            <Select.Option value="lessOrEqualThan">&le;</Select.Option>
          </Select>
        </Col>
        <Col>
          <NumberFormat
            customInput={Input}
            value={selectedKeys && selectedKeys[0]}
            placeholder="0.00"
            decimalScale={2}
            decimalSeparator=","
            thousandSeparator="."
            fixedDecimalScale={true}
            onValueChange={({ floatValue }) =>
              setSelectedKeys(
                floatValue
                  ? selectedKeys && selectedKeys.length > 1
                    ? [floatValue, selectedKeys[1]]
                    : [floatValue, "equal"]
                  : []
              )
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        </Col>
      </Row>

      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm)}
        icon="search"
        size="small"
        style={{
          width: 90,
          marginRight: 8,
          background: "#684e94",
          borderColor: "none",
          border: "none",
        }}
      />
      <Button
        onClick={() => handleReset(clearFilters)}
        icon="delete"
        size="small"
        style={{ width: 90 }}
      />
    </div>
  ),
  filterIcon: (filtered) => (
    <Icon type="search" style={{ color: filtered ? "#684e94" : undefined }} />
  ),
});

export const getColumnNumberWithBetweenSearchProps = (
  dataIndex,
  handleReset,
  handleSearch
) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Row type="flex" gutter={4}>
        <Col>
          <Select
            value={selectedKeys ? selectedKeys[1] : "equal"}
            onChange={(value) =>
              setSelectedKeys(
                value
                  ? selectedKeys
                    ? [selectedKeys[0], value]
                    : [null, value]
                  : []
              )
            }
          >
            <Select.Option value="equal">=</Select.Option>
            <Select.Option value="greaterThan">&gt;</Select.Option>
            <Select.Option value="greaterOrEqualThan">&ge;</Select.Option>
            <Select.Option value="lessThan">&lt;</Select.Option>
            <Select.Option value="lessOrEqualThan">&le;</Select.Option>
            <Select.Option value="between">entre</Select.Option>
          </Select>
        </Col>
        {selectedKeys && selectedKeys[1] === "between" ? (
          <>
            <Col>
              <NumberFormat
                customInput={Input}
                value={selectedKeys && selectedKeys[0]}
                placeholder="0.00"
                decimalScale={2}
                decimalSeparator=","
                thousandSeparator="."
                fixedDecimalScale={true}
                onValueChange={({floatValue}) =>
                  setSelectedKeys(
                    floatValue
                      ? selectedKeys && selectedKeys.length > 1
                        ? [floatValue, selectedKeys[1], selectedKeys[2]]
                        : [floatValue, "equal", selectedKeys[2]]
                      : []
                  )
                }
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
            </Col>
            <Col>
            <NumberFormat
                customInput={Input}
                value={selectedKeys && selectedKeys[2]}
                placeholder="0.00"
                decimalScale={2}
                decimalSeparator=","
                thousandSeparator="."
                fixedDecimalScale={true}
                onValueChange={({floatValue}) =>
                  setSelectedKeys(
                    floatValue
                      ? selectedKeys && selectedKeys.length > 2
                        ? [selectedKeys[0], selectedKeys[1], floatValue]
                        : [selectedKeys[0], "equal", floatValue]
                      : []
                  )
                }
                onPressEnter={() => handleSearch(selectedKeys, confirm)}
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
            </Col>
          </>
        ) : (
          <Col>
            <InputNumber
              value={selectedKeys && selectedKeys[0]}
              placeholder="0.00"
              min={0}
              precision={2}
              step={0.01}
              onChange={(value) =>
                setSelectedKeys(
                  value
                    ? selectedKeys && selectedKeys.length > 1
                      ? [value, selectedKeys[1]]
                      : [value, "equal"]
                    : []
                )
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
          </Col>
        )}
      </Row>

      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm)}
        icon="search"
        size="small"
        style={{
          width: 90,
          marginRight: 8,
          background: "#684e94",
          borderColor: "none",
          border: "none",
        }}
      />
      <Button
        onClick={() => handleReset(clearFilters)}
        icon="delete"
        size="small"
        style={{ width: 90 }}
      />
    </div>
  ),
  filterIcon: (filtered) => (
    <Icon type="search" style={{ color: filtered ? "#684e94" : undefined }} />
  ),
});

/**
 * Retorna o operador SQL equivalente à opção de filtro selecionada.
 * @param {string} filterOption - Opção selecionada do filtro (ex: 'equal', 'greaterThan', etc).
 * @returns {string} Operador SQL correspondente (ex: '=', '>', '<=', 'BETWEEN')
 */
export function getSQLOperatorByFilterOption(filterOption) {
  switch (filterOption) {
    case "equal":
      return "=";
    case "greaterThan":
      return ">";
    case "greaterOrEqualThan":
      return ">=";
    case "lessThan":
      return "<";
    case "lessOrEqualThan":
      return "<=";
    case "between":
      return "BETWEEN";
    default:
      return "=";
  }
}
